import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminReferentialPharmaciesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/referential_pharmacies',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import(
    'pages/admin/ReferentialPharmacies/AdminReferentialPharmaciesPage/AdminReferentialPharmaciesPage'
  ).then((d) => d.Route)
);
